import React, { useState, useEffect } from 'react';
import './LoginPagina.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import backGroundImage from './placeimg_640_480_tech.jpg';
import logoGeoGrid from './logoGeoGrid.svg';

// funcoes
import { useInstalacao } from './../Funcoes/instalacao';

// SUPORTE SO' INSTALADO (20/10/2026, igual a Central web): aberto numa aba do navegador, no lugar do login aparece
// so' o botao para baixar (instalar) o Suporte; ele funciona apenas pelo aplicativo instalado.
// O botao depende do pedido de instalacao do navegador (Chrome/Edge); sem ele (ja instalado, Safari, Firefox) explica o caminho
export default function ExigeInstalacao(){

    const { podeInstalar, instalar } = useInstalacao();
    const [instalado, alterarInstalado] = useState(false);

    useEffect(() => {
        const aoInstalar = () => alterarInstalado(true);
        window.addEventListener('appinstalled', aoInstalar);
        return () => window.removeEventListener('appinstalled', aoInstalar);
    }, []);

    const iPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    // sem o pedido do navegador (acabou de desinstalar, ja instalado...) mostra o caminho manual de cada navegador
    const edge = /Edg\//i.test(navigator.userAgent);
    const chrome = /Chrome\//i.test(navigator.userAgent) && !edge;
    const safari = /Safari/i.test(navigator.userAgent) && !/Chrome|Chromium|Edg|Firefox|FxiOS|CriOS/i.test(navigator.userAgent);

    function dica(){
        if(iPhone) return 'Para instalar no iPhone ou iPad, toque em Compartilhar e depois em "Adicionar à Tela de Início".';
        if(safari) return 'Para instalar no Safari, use o menu Arquivo › "Adicionar ao Dock".';
        if(edge) return 'Para instalar no Edge, use o menu ··· › Aplicativos › "Instalar este site como aplicativo".';
        if(chrome) return 'Para instalar no Chrome, clique no ícone de instalar no canto direito da barra de endereço, ou use o menu ⋮ › Transmitir, salvar e compartilhar › "Instalar página como app".';
        return 'Para instalar, abra este endereço no Google Chrome ou no Microsoft Edge.';
    }

    // retorna componente
    return <div className="container-fluid login-pagina">
        <div className="row no-gutter">
            <div
                className="d-none d-md-flex col-md-4 col-lg-6 bg-image"
                style={{
                    background: `linear-gradient(rgba(0, 0, 0, 0.45),rgba(0, 0, 0, 0.45)),url(${backGroundImage})`,
                    backgroundSize: `cover`
                }}
            />
            <div className="col-md-8 col-lg-6">
                <div className="login d-flex align-items-center py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9 col-lg-8 mx-auto instalacao">
                                <img src={logoGeoGrid} alt="GeoGrid" className="instalacao-logo" />
                                <h3 className="login-heading mb-4">Suporte</h3>

                                {instalado
                                    ? <p>Pronto, o Suporte foi instalado. Abra pelo ícone dele no seu computador ou celular.</p>
                                    : podeInstalar
                                        ? <>
                                            <p>Para usar, baixe o Suporte como aplicativo.</p>
                                            <button
                                                onClick={instalar}
                                                className="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2"
                                                type="button"
                                            >
                                                <FontAwesomeIcon icon={faDownload} /> Baixar o Suporte
                                            </button>
                                        </>
                                        : <>
                                            <p>O Suporte funciona só pelo aplicativo instalado.</p>
                                            <p><strong>Já instalou?</strong> Abra pelo ícone do Suporte.</p>
                                            <p className="instalacao-dica">{dica()}</p>
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
